import api from '../_api';

export const linksService = {
  createLink(edit_pk, format) {
    return api.post('/create-link/', { edit_pk, format });
  },
};
